import { render, staticRenderFns } from "./CompanyUserEditor.vue?vue&type=template&id=998507de&scoped=true&lang=pug"
import script from "./CompanyUserEditor.vue?vue&type=script&lang=ts"
export * from "./CompanyUserEditor.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUserEditor.vue?vue&type=style&index=0&id=998507de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998507de",
  null
  
)

export default component.exports